module.exports = __webpack_public_path__ + "static/media/vf_mshoes_core.51f37d8a.svg";